<div class="filters-container">
  <!-- source Toggle (only shows if options are provided) -->
  @if (sourceOptions.length > 0) {
    <ion-segment [(ngModel)]="sourceId" (ionChange)="onFilterChange()" mode="ios">
      @for (option of sourceOptions; track option.id) {
        <ion-segment-button [value]="option.id">
          <ion-label>{{ option.label | translate }}</ion-label>
        </ion-segment-button>
      }
    </ion-segment>
  }

  <!-- compact Date Range Picker -->
  <div class="date-group">
    <div class="date-item">
      <span>{{ 'DATA_VISUALIZATION.START_DATE' | translate }}</span>
      <ion-datetime-button datetime="start-datetime"></ion-datetime-button>
      <ion-modal [keepContentsMounted]="true"><ng-template>
        <ion-datetime id="start-datetime" presentation="date" [locale]="currentLang" [(ngModel)]="startDate" (ionChange)="onFilterChange()"></ion-datetime>
      </ng-template></ion-modal>
    </div>
    
    <div class="date-item">
      <span>{{ 'DATA_VISUALIZATION.END_DATE' | translate }}</span>
      <ion-datetime-button datetime="end-datetime"></ion-datetime-button>
      <ion-modal [keepContentsMounted]="true"><ng-template>
        <ion-datetime id="end-datetime" presentation="date" [locale]="currentLang" [(ngModel)]="endDate" (ionChange)="onFilterChange()"></ion-datetime>
      </ng-template></ion-modal>
    </div>
  </div>
</div>
